import { render, staticRenderFns } from "./Tanggal.vue?vue&type=template&id=4c78eef3&scoped=true"
import script from "./Tanggal.vue?vue&type=script&lang=js"
export * from "./Tanggal.vue?vue&type=script&lang=js"
import style0 from "./Tanggal.vue?vue&type=style&index=0&id=4c78eef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78eef3",
  null
  
)

export default component.exports